import { IModalAttachment } from '../../../entities/attachment/model/IModalAttachment.interface';

export const processFile = (file: File, tempId: string) => {
    return new Promise<IModalAttachment>((resolve) => {
        const reader = new FileReader();

        reader.onloadend = () => {
            resolve({ file, isLoading: false, id: tempId });
        };

        reader.onerror = () => {
            // @ts-ignore
            console.error(`${i18next.t('processFile.error.text')} ${file.name}`);
            resolve({ file, isLoading: false, id: tempId });
        };

        reader.readAsDataURL(file);
    });
};
